<template>
	<div v-if="mode === 'select'">
		<ul class="merchant_list">
			<li v-for="item in merchantList" :key="item.seq">
				<a @click="selectMerchant(item)">
					<div class="card">
						<div class="d_flex justify_between mb_8">
							<p>{{ $t('merchant.picker.merchant_name') }}</p>
							<p class="shop_name">{{ item.merchant_name }}</p>
						</div>
						<div class="d_flex justify_between mb_8">
							<p>{{ $t('merchant.picker.merchant_id') }}</p>
							<p class="shop_id">{{ item.merchant_id }}</p>
						</div>
						<div class="d_flex justify_between">
							<p>{{ $t('merchant.picker.regist_date') }}</p>
							<p class="date">
								{{ $dayjs(item.regdate).format('YYYY.MM.DD') }}
							</p>
						</div>
					</div>
				</a>
			</li>
			<li>
				<a @click="mode = 'regist'">
					<div class="card border_dashed">
						<span class="icon_add"></span>
					</div>
				</a>
			</li>
		</ul>
	</div>
	<div v-else>
		<div class="mb_20 tal">
			<p class="mb_10">{{ $t('merchant.picker.merchant_name') }}</p>
			<div>
				<input type="text" v-model="merchantName" />
			</div>
		</div>
		<div class="mb_30 tal">
			<p class="mb_10">{{ $t('merchant.picker.merchant_id') }}</p>
			<div>
				<input type="text" v-model="merchantId" />
			</div>
		</div>

		<!--			<button class="fc_black" @click="mode = 'select'">-->
		<!--				{{ $t('button.back') }}-->
		<!--			</button>-->
		<button class="button_round button_bg_red" @click="createMerchant">
			{{ $t('button.register') }}
		</button>
	</div>
	<ModalMessageM v-if="successModal" @closeModal="successModal = false">
		<div class="status_icon success"></div>
		<p class="status_text">{{ $t('merchant.picker.success_shop_register') }}</p>
		<div class="button_area">
			<button class="button_round button_bg_red mt_40" @click="confirm">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
	</ModalMessageM>
</template>

<script>
import { createMerchant, fetchMerchantList } from '@/api/pg';
import { commonError } from '@/common/dialog';
import ModalMessageM from '@/components/Layout/ModalMessage.m';
export default {
	name: 'MerchantPicker.m',
	emits: ['selectMerchant', 'changeMode'],
	components: { ModalMessageM },
	data() {
		return {
			merchantList: [],
			mode: '',
			title: {
				select: this.$t('merchant.picker.title1'),
				regist: this.$t('merchant.picker.title2'),
			},
			merchantName: '',
			merchantId: '',
			successModal: false,
			routeName: '',
		};
	},
	watch: {
		mode(value) {
			if (value) {
				this.merchantName = '';
				this.merchantId = '';
			}
			this.$emit('changeMode', value);
		},
	},
	created() {
		this.mode = 'select';
		this.init();
	},
	methods: {
		init() {
			this.loadMerchantList();
		},
		async loadMerchantList() {
			const { data } = await fetchMerchantList({ no_paging: 1 }).catch(
				commonError,
			);
			this.merchantList = data;
		},
		selectMerchant(merchantInfo) {
			// const routeName =
			// 	this.$route.name === 'management-login'
			// 		? 'qr-scan'
			// 		: 'merchant-console-catalog';

			if (this.$route.name === 'management-login') {
				this.routeName = 'qr-payment';
			} else if (this.$route.name === 'qr-payment') {
				this.routeName = 'qr-payment';
			} else if (this.$route.name === 'payment-list') {
				this.routeName = 'payment-list';
			} else {
				this.routeName = 'merchant-console-catalog';
			}

			const obj = {
				name: this.routeName,
				params: {
					merchant_seq: merchantInfo.seq,
					merchant_name: merchantInfo.merchant_name,
					merchant_id: merchantInfo.merchant_id,
				},
			};
			this.$emit('selectMerchant', obj);
		},
		async createMerchant() {
			if (!this.validations()) return;
			const params = {
				merchant_name: this.merchantName,
				merchant_id: this.merchantId,
			};
			await createMerchant(params)
				.then(() => {
					this.successModal = true;
					// 임시
					// alert(this.$t('merchant.picker.success_shop_register'));
					this.isSelectMode = true;
					this.loadMerchantList();
				})
				.catch(commonError);
		},
		validations() {
			if (!this.merchantName) {
				alert(this.$t('merchant.picker.insert_shop_name'));
				return false;
			}
			if (!this.merchantId) {
				alert(this.$t('merchant.picker.insert_shop_id'));
				return false;
			}
			return true;
		},
		confirm() {
			this.successModal = false;
			this.isSelectMode = true;
		},
	},
};
</script>
